class UserLanguage {
  constructor() {
    this.language = null
  }

  get lang() {
    return this.language
  }

  setLanguage(language) {
    this.language = language
  }
}

const userLanguage = new UserLanguage()

export default userLanguage